<template>
    <button
        type="button"
        :class="$style.button"
        data-interface-target="play-on-app-header-button"
        @click="emit('click')"
    >
        <span :class="$style.icons">
            <img
                :class="$style.icon"
                :src="AppleImg"
                alt="Apple AppStore"
            />
            <img
                :class="$style.icon"
                :src="GooglePlayImg"
                alt="Google Play"
            />
        </span>
        <Typography
            type="caption"
            size="all-caps"
            semibold
            :class="$style.label"
        >
            {{ $tr('header.playOnApp') }}
        </Typography>
    </button>
</template>

<script setup lang="ts">
import Typography from '@/components/Typography.vue'

import AppleImg from './images/apple.svg'
import GooglePlayImg from './images/google-play.svg'

const emit = defineEmits<{ click: [] }>()
</script>

<style module>
.button {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 56px;
    padding: 4px 8px;
    border: none;
    border-radius: 1000px;
    background: var(--carbon-400);
    cursor: pointer;
    transition: box-shadow 0.3s;
}

.button:hover,
.button:focus {
    box-shadow: 0 0 30px 0 rgba(163, 109, 253, 0.64) inset;
    outline: 0.5px solid var(--purple-300);
}

.icons {
    display: flex;
    align-items: center;
    gap: 4px;
}

.icon {
    width: 32px;
    height: 40px;
}

.label {
    display: none;
    max-width: 48px;
    min-width: min-content;
    text-align: left;
    text-wrap: balance;
    font-size: 11px;
    line-height: 1.06;
    letter-spacing: 0.33px;
    color: #b4bacb;
}

@media (--desktop-medium-plus) {
    .button {
        padding: 4px 16px 4px 8px;
    }

    .label {
        display: block;
    }
}
</style>
